"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMAIN_VERSION = void 0;
/** Shared, transport-independent contracts for Web and API. */
var version_js_1 = require("./version.js");
Object.defineProperty(exports, "DOMAIN_VERSION", { enumerable: true, get: function () { return version_js_1.DOMAIN_VERSION; } });
__exportStar(require("./common.js"), exports);
__exportStar(require("./organisation.js"), exports);
__exportStar(require("./projects.js"), exports);
__exportStar(require("./employees.js"), exports);
__exportStar(require("./work-packages.js"), exports);
__exportStar(require("./planning.js"), exports);
__exportStar(require("./requests.js"), exports);
__exportStar(require("./time.js"), exports);
__exportStar(require("./pacs-sync.js"), exports);
__exportStar(require("./pacs-mapping.js"), exports);
__exportStar(require("./rbac.js"), exports);
__exportStar(require("./tenant-settings.js"), exports);
__exportStar(require("./principals.js"), exports);
__exportStar(require("./ansichten.js"), exports);
//# sourceMappingURL=index.js.map